<div class="d-flex align-items-center position-relative">
      <i class="fa fa-circle pe-2" *ngIf="params?.colorCode" 
      [style.color]="color" style="font-size: x-small; margin-left: .5em;"></i>
      <span class="text-info-color">{{inputValue}}</span>
</div>

